module.exports = "https://static.energy5.com/_next/static/images/universalCharger-de5cc10ecec125f7a547d08a27b75bef.png";